import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  menu: JSON.parse(localStorage.getItem("cohort_menu")) || [],
  all: JSON.parse(localStorage.getItem("cohort_all")) || []
};

const cohortSlice = createSlice({
  name: "cohort",
  initialState,
  reducers: {
    // BULK SET FROM SIDEBAR API
    setAllCohorts: (state, action) => {
      state.all = action.payload;
      localStorage.setItem("cohort_all", JSON.stringify(state.all));
    },

    // BULK SET MENU FROM SIDEBAR API
    setMenuCohorts: (state, action) => {
      state.menu = action.payload;
      localStorage.setItem("cohort_menu", JSON.stringify(state.menu));
    },

    // APPEND NEW PROMPT RESPONSE
    addToAllCohorts: (state, action) => {
      state.all.push(action.payload);
      localStorage.setItem("cohort_all", JSON.stringify(state.all));
    },

    // ADD MENU ITEM ONLY IF TRACE DOES NOT EXIST
    addMenuIfNotExists: (state, action) => {
      const exists = state.menu.some(
        item => item.trace_id === action.payload.trace_id
      );

      if (!exists) {
        state.menu.unshift(action.payload);
        localStorage.setItem(
          "cohort_menu",
          JSON.stringify(state.menu)
        );
      }
    }
  }
});

export const {
  setAllCohorts,
  setMenuCohorts,
  addToAllCohorts,
  addMenuIfNotExists
} = cohortSlice.actions;

export default cohortSlice.reducer;
